/* eslint-disable no-negated-condition */
import React, {useEffect, useState} from 'react';
import './stylesheets/styles.scss';
/* import {Quiz} from './routes'; */
import Lottie from './components/lottie';
import store from './store';
import {StoreProvider} from 'easy-peasy';
import Router from './components/router';
import {loadIntroAnimations, loadQ1Animations} from './utils/animation';
import {loadQueriedAnimations} from './utils/queryParsing';
import LegalFooter from "./components/legalFooter";

window.store = store;

export default () => {
    const [isLoaded, setLoaded] = useState(false);

    useEffect(() => {
        Promise.all([loadIntroAnimations(), loadQueriedAnimations()])
            .then(() => {
                setLoaded(true);

                return loadQ1Animations();
            })
            .catch(console.error);
    });

    return (
        <StoreProvider store={store}>
            <div className="iframe-scroll-container">
                <div className="App" aria-live="assertive" role="region" id="App" aria-atomic="false">
                    {isLoaded && (
                        <>
                            <Lottie />
                            <Router />
                        </>
                    )}
                </div>
                <LegalFooter from={`app`}/>
            </div>
        </StoreProvider>
    );
};
